import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { requestSignOut } from '@/store/actions/authenticate';
import Button from '@/components/common/button';

const SignOut = () => {
  const dispatch = useDispatch();
  const [signOutUrl, setSignOutUrl] = useState(null);

  useEffect(() => {
    if (signOutUrl) {
      window.location.href = signOutUrl;
    }
  }, [signOutUrl]);

  const onClickLogout = () => {
    dispatch(
      requestSignOut((val) => {
        setSignOutUrl(val);
      }),
    );
  };

  return (
    <Button type="text" size="large" block onClick={onClickLogout} className="justify-left">
      Sign Out
    </Button>
  );
};
export default SignOut;
